import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar
} from '@material-ui/core';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {},
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function IletisimDetay({ className }) {
  const classes = useStyles();
  const { t } = useTranslation('service_contact');
  const SessionUser = getUser();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.'
  });
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const [Data, setData] = React.useState([]);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios
        .get('/GetSiriusSupportInformation')
        .then(response => {
          if (mounted) {
            const Deger = response.data === '' ? [] : response.data;
            setData(Deger);
          }
        })
        .catch(error => {});
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, []);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleFgsAramaYap = Telefon => {
    // var Uyari = "Merhaba " + SessionUser.FirstName + ", seni hemen servis merkezine ait " + Telefon + " no'lu telefon numarasına bağlayacağım. Aramayı başlatmamı ister misin? ";
    const Uyari = t('uyari').replace('@firstname', SessionUser.FirstName);
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: t('Evet'),
          onClick: () => handleFgsAramaYapEvet(Telefon)
        },
        {
          label: t('Hayir'),
          onClick: () => {}
        }
      ]
    });
  };
  const handleFgsAramaYapEvet = Telefon => {
    const phoneNumber = Telefon;
    window.open(`tel:${phoneNumber}`, '_self');
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Bilgilendirme
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {LoadingControl ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <div />
          )}
          {Data.map(item => (
            <div className={classes.wrapper} key={item.Phone}>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => handleFgsAramaYap(item.Phone)}
                endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
              >
                {item.Dsc} :
{item.Phone}
              </Button>
              <br />
              <br />
            </div>
          ))}

          <br />
          <br />
          <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={5000}>
            <Alert
              onClose={uyariKapat}
              message={responseMessage.ErrorDescription}
              variant={uyariTip}
            />
          </Snackbar>
        </CardContent>
      </Card>
    </div>
  );
}

IletisimDetay.propTypes = {
  className: PropTypes.string
};

export default IletisimDetay;
